/* ==========================================================================
   Lara Valenti - Cart Drawer (estilo UpCart)
   ========================================================================== */
(function () {
  'use strict';

  var SECTION_ID = 'lv-cart-drawer';
  var TIMER_KEY = 'lvCartTimerDeadline';

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function url(path) {
    return root().replace(/\/$/, '') + path;
  }

  /* ---------------------------------------------------------------- Drawer */
  class LvCartDrawer extends HTMLElement {
    connectedCallback() {
      if (this.__init) return;
      this.__init = true;

      this.addEventListener('click', this.onClick.bind(this));
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') this.close();
      }.bind(this));

      this.startTimer();
    }

    onClick(e) {
      var closer = e.target.closest('[data-lv-close]');
      if (closer) {
        e.preventDefault();
        this.close();
        return;
      }

      var qtyBtn = e.target.closest('[data-lv-qty]');
      if (qtyBtn) {
        e.preventDefault();
        var row = qtyBtn.closest('[data-lv-line]');
        if (!row) return;
        this.changeLine(row.dataset.lvLine, qtyBtn.dataset.lvQty);
      }
    }

    open() {
      this.classList.add('is-open');
      document.body.classList.add('lv-cd-open');
      this.startTimer();
      document.dispatchEvent(new CustomEvent('lv-cart-drawer:open'));
    }

    close() {
      this.classList.remove('is-open');
      document.body.classList.remove('lv-cd-open');
    }

    /* ------------------------------------------------------- Cart actions */
    changeLine(line, quantity) {
      this.classList.add('is-loading');
      return fetch(url('/cart/change.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: Number(quantity) })
      })
        .then(function (r) {
          return r.json();
        })
        .then(
          function () {
            return this.refresh();
          }.bind(this)
        )
        .catch(
          function () {
            this.classList.remove('is-loading');
          }.bind(this)
        );
    }

    addFromForm(form) {
      var body = new FormData(form);
      this.classList.add('is-loading');
      return fetch(url('/cart/add.js'), {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: body
      })
        .then(function (r) {
          return r.json().then(function (data) {
            return { ok: r.ok, data: data };
          });
        })
        .then(
          function (res) {
            if (!res.ok) {
              this.classList.remove('is-loading');
              if (res.data && res.data.description) window.alert(res.data.description);
              return;
            }
            this.resetTimer();
            return this.refresh().then(
              function () {
                this.open();
              }.bind(this)
            );
          }.bind(this)
        )
        .catch(
          function () {
            this.classList.remove('is-loading');
          }.bind(this)
        );
    }

    saveNote(value) {
      return fetch(url('/cart/update.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: value })
      });
    }

    /* ----------------------------------------------------------- Refresh */
    refresh() {
      return fetch(url('/?sections=' + SECTION_ID + ',cart-icon-bubble'))
        .then(function (r) {
          return r.json();
        })
        .then(
          function (data) {
            var parser = new DOMParser();

            if (data[SECTION_ID]) {
              var doc = parser.parseFromString(data[SECTION_ID], 'text/html');
              var fresh = doc.querySelector('.lv-cd__panel');
              var freshRoot = doc.querySelector('lv-cart-drawer');
              var panel = this.querySelector('.lv-cd__panel');
              if (fresh && panel) panel.innerHTML = fresh.innerHTML;
              if (freshRoot) this.dataset.itemCount = freshRoot.dataset.itemCount || '0';
            }

            if (data['cart-icon-bubble']) {
              var bDoc = parser.parseFromString(data['cart-icon-bubble'], 'text/html');
              var src = bDoc.querySelector('#shopify-section-cart-icon-bubble') || bDoc.body;
              document.querySelectorAll('#cart-icon-bubble').forEach(function (el) {
                el.innerHTML = src.innerHTML;
              });
            }

            this.classList.remove('is-loading');
            this.startTimer();
            document.dispatchEvent(new CustomEvent('lv-cart-drawer:updated'));
          }.bind(this)
        )
        .catch(
          function () {
            this.classList.remove('is-loading');
          }.bind(this)
        );
    }

    /* ------------------------------------------------------------- Timer */
    resetTimer() {
      try {
        sessionStorage.removeItem(TIMER_KEY);
      } catch (e) {}
    }

    startTimer() {
      if (this.__tick) clearInterval(this.__tick);

      var wrap = this.querySelector('[data-lv-timer-wrap]');
      var out = this.querySelector('[data-lv-timer]');
      if (!wrap || !out) return;

      var minutes = parseInt(wrap.dataset.minutes, 10) || 8;
      var deadline = 0;

      try {
        deadline = parseInt(sessionStorage.getItem(TIMER_KEY), 10) || 0;
      } catch (e) {}

      if (!deadline || deadline <= Date.now()) {
        deadline = Date.now() + minutes * 60000;
        try {
          sessionStorage.setItem(TIMER_KEY, String(deadline));
        } catch (e) {}
      }

      var render = function () {
        var left = Math.max(0, Math.floor((deadline - Date.now()) / 1000));
        var m = String(Math.floor(left / 60)).padStart(2, '0');
        var s = String(left % 60).padStart(2, '0');
        out.textContent = m + ':' + s;
        if (left <= 0) {
          deadline = Date.now() + minutes * 60000;
          try {
            sessionStorage.setItem(TIMER_KEY, String(deadline));
          } catch (e) {}
        }
      };

      render();
      this.__tick = setInterval(render, 1000);
    }
  }

  if (!customElements.get('lv-cart-drawer')) {
    customElements.define('lv-cart-drawer', LvCartDrawer);
  }

  /* ------------------------------------------------------------- Globals */
  function drawer() {
    return document.querySelector('lv-cart-drawer');
  }
  window.lvCartDrawer = {
    open: function () {
      var d = drawer();
      if (d) d.open();
    },
    close: function () {
      var d = drawer();
      if (d) d.close();
    },
    refresh: function () {
      var d = drawer();
      return d ? d.refresh() : Promise.resolve();
    }
  };

  /* --------------------------------------------- Abrir desde icono/enlaces */
  document.addEventListener(
    'click',
    function (e) {
      var link = e.target.closest('a[href], button');
      if (!link) return;
      if (link.closest('lv-cart-drawer')) return;

      var isCart =
        link.id === 'cart-icon-bubble' ||
        link.classList.contains('header__icon--cart') ||
        /(^|\/)cart\/?($|\?)/.test(link.getAttribute('href') || '');

      if (!isCart) return;

      var d = drawer();
      if (!d) return;
      e.preventDefault();
      e.stopPropagation();
      d.open();
    },
    true
  );

  /* ------------------------------------------- Interceptar anadir al carrito */
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      var action = form.getAttribute('action') || '';
      if (action.indexOf('/cart/add') === -1) return;

      var d = drawer();
      if (!d) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      var btn = form.querySelector('[type="submit"], [name="add"]');
      if (btn) {
        btn.setAttribute('aria-busy', 'true');
        btn.disabled = true;
      }

      d.addFromForm(form).then(function () {
        if (btn) {
          btn.removeAttribute('aria-busy');
          btn.disabled = false;
        }
      });
    },
    true
  );

  /* ----------------------------------------------------- Nota del pedido */
  var noteTimer;
  document.addEventListener('input', function (e) {
    var ta = e.target.closest('[data-lv-note]');
    if (!ta) return;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () {
      var d = drawer();
      if (d) d.saveNote(ta.value);
    }, 500);
  });
})();
